export default [
  {
    meta: {
      title: "CalWreath"
    },
    path: "/cal/wreath",
    name: "CalWreath",
    component: () => import("@/views/cal/CalWreath.vue")
  },
  {
    meta: {
      title: "CalWreathDetail"
    },
    path: "/cal/wreath-detail",
    name: "CalWreathDetail",
    component: () => import("@/views/cal/CalWreathDetail.vue")
  }
];
